<template>
	<div class="msg_box">
		<div class="tech_title">实验工具</div>
		<div v-loading="loading" class="tool_box clearfloat min_he400">
			<!-- <div class="tool_xishi">
				<p class="tool_title">稀释计算器</p>
				<div class="tool_hui">用本工具协助配置特定求度的高清,使用的计算公式为:</div>
				<div class="tool_lan">开始浓度X开始体积=最终浓度X最终体积</div>
				<div class="tool_hui">稀释公式</div>
				<div class="tool_hui">稀释公式一般简略地表示为:<span class="tool_lan">C1V1=C2V2(输入输出)</span></div>
			</div> -->
			<div class="tool_xishi" v-for="(item,i) in toolList" :key="item.id">
				<p class="tool_title">{{item.title}}</p>
				<div v-html="item.intr"></div>
				<div class="tool_imgs">
					<img v-if="i==0" @click="xin.goUrl('/dilutionCalculator')" :src="item.images" alt="">
					<img v-else-if="i==1" @click="xin.goUrl('/molalityCalculator')" :src="item.images" alt="">
					<img v-else @click="xin.goNew(item.url)" :src="item.images" alt="">
				</div>
			</div>
		</div>
		<!-- <div class="tool_box clearfloat">
			<div class="tool_xishi flo_lf">
				<p class="tool_title2">
					<span @click="xin.goUrl('/dilutionCalculator')">点击图片进入 <span class="el-icon-arrow-right"></span></span>
				</p>
				<div class="tool_imgs">
					<img @click="xin.goUrl('/dilutionCalculator')" src="@/assets/images/tool1.png" alt="">
				</div>
			</div>
			<div class="tool_nodu flo_right">
				<p class="tool_title2">
					<span  @click="xin.goUrl('/molalityCalculator')">点击图片进入 <span class="el-icon-arrow-right"></span></span>
				</p>
				<div class="tool_imgs">
					<img  @click="xin.goUrl('/molalityCalculator')" src="@/assets/images/tool2.png" alt="">
				</div>
			</div>
		</div> -->
	</div>
</template>
<script>
export default {
	data(){
		return{
			loading:true,
			toolList:[]
		}
	},
	created(){
		this.Posttool();
	},
	methods:{
		async Posttool(){
			this.loading = true;
            let {data} = await this.api.Posttool();
            data.forEach(v=>{
                if(v.url){
                    v.url = v.url.replace('http','https')
                }
            })
            console.log(data,"@@@");
			this.toolList = data;
			this.loading = false;
		}
	}
}
</script>
<style lang="scss" scoped>
.tool_box{
	display: flex;
	flex-wrap: wrap;
	.tool_title{
		font-size: 18px;
		font-weight: 600;
		color: #333333;
		line-height: 36px;
	}
	.tool_xishi{
		padding:0 20px;
		div{
			margin: 10px 0;
		}
	}
	.tool_imgs{
		cursor: pointer;
		img{
			width: 545px;
			height: 400px;
		}
	}
	.tool_title2{
		margin-top: 50px;
		font-size: 20px;
		font-weight: 500;
		color: #005599;
		line-height: 36px;
		span{
			cursor: pointer;
		}
	}
	.tool_hui{
		color: #666666;
	}
	.tool_lan{
		color: #005599;
	}
	&> div{
		width: 545px;

	}
}
</style>